import axios from "axios";

/**
 * 内部 CRM（crm.smartsolo.com）的对外接口
 *
 * 这几个接口不走 /api 反向代理，直接请求 CRM 域名。
 * CRM 侧 #lib/wx_api.php 里已经放行了 wx.smartsolo.com.cn 的跨域，
 * 并且处理了浏览器的 OPTIONS 预检请求。
 *
 * 注意：本地 npm run serve 调这些接口会被 CORS 拦（来源不是 wx.smartsolo.com.cn），
 * 需要部署到线上才能联调。
 */
const CRM_BASE = "https://crm.smartsolo.com/";

function crmPost(action, data) {
  // 故意用 text/plain 而不是 application/json：
  // application/json 属于"非简单请求"，浏览器会先发一个 OPTIONS 预检，
  // 而 CRM 服务器的 Nginx 对 OPTIONS 直接返回 405，预检失败后真正的 POST
  // 根本不会发出去。text/plain 属于简单请求，不触发预检。
  // 服务端 wx_api.php 是读 php://input 再 json_decode，跟 Content-Type 无关，
  // 所以这么发完全兼容。
  return axios
    .post(CRM_BASE + "?Api=wx&a=" + action, JSON.stringify(data), {
      timeout: 20000,
      headers: { "Content-Type": "text/plain;charset=UTF-8" },
    })
    .then((res) => res.data);
}

/** 提交许可申请工单后，记录 openid 与机器码的对应关系 */
export function crmBindLicense(data) {
  return crmPost("bind", data);
}

/** 查询该 openid 名下的许可（状态 + 下载链接） */
export function crmMyLicenses(data) {
  return crmPost("list", data);
}

/** 把许可重新发送到客户邮箱 */
export function crmResendLicense(data) {
  return crmPost("resend", data);
}

// ====== 一次性订阅消息（「SmartSolo科学仪器」公众号）======
// 注意：这里的 appid 和 H5 换 openid 用的那个不是同一个号。
// 换 openid 走的是「高可靠地震仪」服务号（历史遗留），推送走这个号。
// 两套 openid 各存各的，互不影响，所以不需要动 appid、也不需要后端配合。
const MP_APPID = "wxe740d597bd5a8144";
const MP_TEMPLATE_ID = "XR8dfjlYdTQCory9cmuci4Xy3tgZ4-ys5orY8o4XIAk";
const MP_SCENE = "1000";

/**
 * 拼订阅消息授权链接
 *
 * 客户点「允许」后微信会 302 到 CRM 的 ?Api=wxsub，由 CRM 记下 openid，
 * 再跳回提交成功页。reserved 原样带回，CRM 用它和 oid 比对防篡改。
 *
 * 末尾的 #wechat_redirect 不能少，少了微信不认这个链接。
 */
export function buildSubscribeUrl(orderNo, email) {
  const redirect =
    CRM_BASE +
    "?Api=wxsub&oid=" +
    encodeURIComponent(orderNo) +
    "&em=" +
    encodeURIComponent(email || "");
  return (
    "https://mp.weixin.qq.com/mp/subscribemsg?action=get_confirm" +
    "&appid=" + MP_APPID +
    "&scene=" + MP_SCENE +
    "&template_id=" + MP_TEMPLATE_ID +
    "&redirect_url=" + encodeURIComponent(redirect) +
    "&reserved=" + encodeURIComponent(orderNo) +
    "#wechat_redirect"
  );
}
